




import { Vue, Component } from 'vue-property-decorator';
import { orderListTypes, focusTabName } from '@/const/order';
import ContentBottom from '@/components/shipping/order/ContentBottom.vue';

@Component({
  components: {
    ContentBottom,
  },
})
export default class OrderDeliveryPrepare extends Vue {
  private orderListTypes = orderListTypes.DELIVERY_PREPARE;
  private orderSearchTypes = focusTabName.DELIVERY_TAB;
}
